import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/page.tsx");
